import React from "react";
import CtCarousel from "../carousel/CtCarousel";
import { Theme, ThemeFontVariant, ThemeIntent } from "../types";
import { BemHelper } from "@/utils/BemHelper";
import classNames from "classnames";
import { OpenQuoteIcon } from "@/icons/primary/open-quote-icon";
import { CloseQuoteIcon } from "@/icons/primary/close-quote-icon";
import { THEMES, THEME_FONT_VARIANTS, THEME_INTENTS } from "../constants";
import { useActiveBreakpoints } from "@/utils/useActiveBreakpoints";

export type CarouselTestimonial = {
  description: string;
  name: string;
  position: string;
};

export type CtTestimonialsProps = {
  testimonials: CarouselTestimonial[];
  theme?: Theme;
  intent?: ThemeIntent;
  fontVariant?: ThemeFontVariant;
};

const bem = new BemHelper("ct-testimonials");

function CtTestimonials({ testimonials, theme, intent, fontVariant }: CtTestimonialsProps) {
  const { activeBreakpoints } = useActiveBreakpoints();

  return (
    <div
      className={classNames(
        bem.block(),
        bem.modifier(fontVariant || THEME_FONT_VARIANTS.FONT_VARIANT_1),
        !activeBreakpoints.md && bem.modifier("mobile"),
      )}
    >
      <CtCarousel
        slides={testimonials}
        slidesToShow={1}
        spaceBetween={!activeBreakpoints.md ? 4 : 16}
        adaptiveHeight
        renderSlide={(testimonial) => (
          <div
            className={classNames(
              bem.element("slide"),
              bem.modifier(theme || THEMES.THEME_1, "slide"),
              bem.modifier(intent || THEME_INTENTS.DEFAULT, "slide"),
            )}
          >
            <div
              className={classNames(
                bem.element("slide-description"),
                !activeBreakpoints.md && bem.modifier("mobile", "slide-description"),
              )}
            >
              <div className={classNames(bem.element("slide-inner"))}>
                <div
                  className={classNames(
                    bem.element("quote-icon"),
                    bem.modifier("open", "quote-icon"),
                    !activeBreakpoints.md && bem.modifier("mobile", "quote-icon"),
                  )}
                >
                  <OpenQuoteIcon />
                </div>
                <div>{testimonial.description}</div>
                <div
                  className={classNames(
                    bem.element("quote-icon"),
                    bem.modifier("close", "quote-icon"),
                    !activeBreakpoints.md && bem.modifier("mobile", "quote-icon"),
                  )}
                >
                  <CloseQuoteIcon />
                </div>
              </div>
              <div className={classNames(bem.element("slide-meta"))}>
                <div className={classNames(bem.element("slide-name"))}>{testimonial.name}</div>
                <div className={classNames(bem.element("slide-position"))}>
                  {testimonial.position}
                </div>
              </div>
            </div>
          </div>
        )}
        theme={theme}
        intent={intent}
      />
    </div>
  );
}

CtTestimonials.defaultProps = {
  theme: THEMES.THEME_1,
  intent: THEME_INTENTS.DEFAULT,
};

export default CtTestimonials;
